/**
 * Runtime environment — sole module that reads import.meta.env (Vite).
 * Production keeps REACT_APP_* keys in server .env; no rename required.
 */
export const env = {
  apiBaseUrl: import.meta.env.REACT_APP_API_BASE_URL ?? '',
  secretEncryptionKey: import.meta.env.REACT_APP_SECRET_ENCRYPTION_KEY ?? '',
  staticEncryptionKey: import.meta.env.REACT_APP_STATIC_ENCRYPTION_KEY ?? '',
  staticEncryptionIv: import.meta.env.REACT_APP_STATIC_ENCRYPTION_IV ?? '',
  googleMapsApiKey: import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
  pusher: {
    appKey: import.meta.env.REACT_APP_PUSHER_APP_KEY ?? '',
    host: import.meta.env.REACT_APP_PUSHER_HOST ?? '',
    port: import.meta.env.REACT_APP_PUSHER_PORT ?? '',
    scheme: import.meta.env.REACT_APP_PUSHER_SCHEME ?? '',
    cluster: import.meta.env.REACT_APP_PUSHER_APP_CLUSTER ?? '',
  },
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
};
